import React from "react";
import Company from "../Components/Common/HeadTitle";
import TecTabs from "../Components/Technology/TecTabs";

// 보유기술 화면배치
function Technology() {
  return (
    <div>
      <Company />
      <TecTabs />
    </div>
  );
}

export default Technology;
